import { Box, BoxProps } from "@mui/material"
import styles from "./Loader.module.css"

const InfiLoader = (props: BoxProps) => {
  return <Box {...props} className={styles.InfiLoader}></Box>
}

export default InfiLoader
